import React from "react";
import { motion } from "framer-motion";
import { useI18n } from "@/i18n";

export default function Marquee() {
  const { t } = useI18n();
  const items = [...t.marquee, ...t.marquee, ...t.marquee];

  return (
    <section
      data-testid="marquee-section"
      className="relative bg-black border-y border-white/5 overflow-hidden py-6"
    >
      <div className="flex animate-marquee whitespace-nowrap">
        {items.map((w, i) => (
          <div
            key={i}
            className="flex items-center gap-12 mx-6 text-white/30 font-display"
          >
            <span className="text-xl md:text-2xl tracking-tight font-light">
              {w}
            </span>
            <span className="text-lux/40 text-lg">✦</span>
          </div>
        ))}
      </div>
    </section>
  );
}
